import Image from 'app/Components/Shared/Image/image';
import React, {useContext} from 'react';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';
import ConfettiComponent from 'app/utilities/confetti';

function SimSuccess() {
  const [{links}, dispatch] = useContext(SimActivationContext);

  return (
    <div className='SimSuccess'>
      <ConfettiComponent />
      <h1 className='SimActivationBlock__main__title' />
      <h1 className='SimActivationBlock__top__title'>הניוד הושלם :)</h1>
      <p className='SimActivationBlock__top__link'>הסים פועל ועכשיו אפשר לגלוש, לדבר ולסמס.</p>

      <div className='SimActivationBlock__image'>
        <Image src={require('../images/icons-ok-done.svg')} />
      </div>

      <div className='SimActivationBlock__bottom__link'>
        <a href={links.personalAreaUrl}>לאזור האישי שלך </a>
      </div>

      <div className='SimActivationBlock__bottom__link'>
        <a onClick={() => dispatch({type: 'init'})}>רוצה להפעיל סים נוסף?</a>
      </div>
    </div>
  );
}

export default SimSuccess;
